import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import PlayIcon from '../assets/images/play.svg';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';

interface IProps {
  onPress(): void;
}

const playIconSize = defaultScale(75);
const VideoPlayBackButton: React.FC<IProps> = ({ onPress }) => {
  return (
    <TouchableOpacity style={styles.playButtonContainer} onPress={onPress}>
      <PlayIcon width={playIconSize} height={playIconSize} color={theme.PRIMARY} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  playButtonContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: [
      { translateX: -defaultScale(playIconSize / 2) },
      { translateY: -defaultScale(playIconSize / 2) },
    ],
    zIndex: 100,
  },
});
export default VideoPlayBackButton;
